import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import { useEnabledFlagList } from './hooks/useEnabledFlagList';
export default function withFeatureFlags(Component) {
    const Decorated = (props)=>{
        const flags = useEnabledFlagList();
        return /*#__PURE__*/ React.createElement(Component, _object_spread({
            flags: flags
        }, props));
    };
    Decorated.displayName = `withFeatureFlags(${Component.displayName || 'Component'})`;
    return Decorated;
}
